import React from 'react'
import Text from '../text/Text'
import './PromotionCard.css'
import { isAdmin } from '../../Utils/Profile'

interface PromotionCardProps {
    promoName: string
    fromDate: string
    toDate: string
    validFor: string
    onClick: () => void
    deletePromotion: (idPromocion: string) => void
    idPromocion: string
}

const PromotionCard: React.FC<PromotionCardProps> = ({
    promoName,
    fromDate,
    toDate,
    validFor,
    onClick,
    deletePromotion,
    idPromocion,
}) => {
    return (
        <div className="promotion-card-parent">
            <div className="promotion-card-container">
                <Text
                    label="Nombre de la promo"
                    fontSize={10}
                    fontWeight={400}
                    color={'#565656'}
                    marginTop={10}
                    marginLeft={30}
                />
                <div className="promotion-card-flex">
                    <div
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '80%',
                            display: 'inline-block',
                        }}
                    >
                        <Text
                            label={promoName}
                            fontSize={24}
                            fontWeight={600}
                            color={'#565656'}
                            marginLeft={30}
                            whiteSpace="nowrap"
                            variant="promotion-card-text"
                        />
                    </div>

                    {isAdmin() && (
                        <div
                            className="promotion-delete-button pointer"
                            onClick={(event) => {
                                event.stopPropagation()
                                deletePromotion(idPromocion)
                            }}
                        >
                            <Text label="Eliminar" color="white" />
                        </div>
                    )}
                </div>

                <div className="promotion-card-flex promotion-card-flex-data-detail">
                    <div className="promotion-card-flex">
                        <Text
                            label="Desde:"
                            fontSize={10}
                            fontWeight={400}
                            color={'#565656'}
                            marginLeft={15}
                            marginBottom={7}
                            marginRight={5}
                        />
                        <Text
                            label={fromDate}
                            fontSize={13}
                            fontWeight={600}
                            color={'#565656'}
                            marginBottom={7}
                        />
                    </div>
                    <div className="promotion-card-flex">
                        <Text
                            label="Hasta:"
                            fontSize={10}
                            fontWeight={400}
                            color={'#565656'}
                            marginLeft={15}
                            marginBottom={7}
                            marginRight={5}
                        />
                        <Text
                            label={toDate}
                            fontSize={13}
                            fontWeight={600}
                            color={'#565656'}
                            marginBottom={7}
                        />
                    </div>
                    <div className="promotion-card-flex">
                        <Text
                            label="Válido para:"
                            fontSize={10}
                            fontWeight={400}
                            color={'#565656'}
                            marginLeft={15}
                            marginBottom={7}
                            marginRight={5}
                        />
                        <Text
                            label={validFor}
                            fontSize={13}
                            fontWeight={600}
                            color={'#565656'}
                            marginBottom={7}
                        />
                    </div>
                </div>
                <div
                    className="promotion-detail-button pointer"
                    onClick={onClick}
                >
                    <Text label="Ver detalle" color={'#565656'} />
                </div>
            </div>
        </div>
    )
}

export default PromotionCard
